module.exports = __webpack_public_path__ + "images/140_4096.jpg";